import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const PaymentPolicy = () => {
  document.title = "Payment Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Payment Policy</h1>

              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>MordenBazaar provides secure, fast, and reliable payment options.</li>
                <li>This policy explains payment methods, charges, refunds, and security practices.</li>
                <li>By placing an order, you agree to this Payment Policy.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Accepted Payment Methods</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Credit Cards (Visa, MasterCard, RuPay, American Express).</li>
                <li>Debit Cards (Visa, MasterCard, Maestro, RuPay).</li>
                <li>UPI (Google Pay, PhonePe, Paytm, BHIM UPI).</li>
                <li>Net Banking from all major Indian banks.</li>
                <li>Cash on Delivery (CoD) for eligible PIN codes.</li>
              </ul>

              <h3 className="mt-4 mb-2 font-semibold">Upcoming Payment Options</h3>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Digital Wallets.</li>
                <li>EMI and Buy Now Pay Later (BNPL) options.</li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Pricing & Additional Charges</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>All prices include applicable taxes unless stated otherwise.</li>
                <li>
                  Shipping charges:
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Free shipping on orders above ₹1,499.</li>
                    <li>₹50 shipping fee on orders below ₹1,499.</li>
                  </ul>
                </li>
                <li>No additional fee is charged for Cash on Delivery (if applicable).</li>
                <li>Limited-time payment discounts may be available at checkout.</li>
                <li>Instant cashback is not currently supported.</li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. Cash on Delivery (CoD)</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Payment is collected in cash at the time of delivery.</li>
                <li>CoD is available only for select serviceable locations.</li>
                <li>Maximum CoD order value is ₹50,000 per order.</li>
                <li>Repeated CoD cancellations may result in CoD being disabled.</li>
                <li>A 10% cancellation fee may apply if a CoD order is refused after dispatch.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. High-Value Order Verification</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Orders above ₹50,000 may require additional verification.</li>
                <li>Pre-payment may be requested for security reasons.</li>
                <li>Customers will be informed in advance in such cases.</li>
              </ul>

              {/* 5 */}
              <h2 className="mt-5 mb-3">5. Payment Security & Fraud Protection</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>All online transactions use 256-bit SSL encryption.</li>
                <li>MordenBazaar does not store card or UPI details.</li>
                <li>Suspicious payments may be held or cancelled for verification.</li>
                <li>Fraudulent activity may result in permanent account suspension.</li>
              </ul>

              {/* 6 */}
              <h2 className="mt-5 mb-3">6. Payment Timing & Refunds</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Online payments are charged immediately at order placement.</li>
                <li>CoD payments are collected upon delivery.</li>
                <li>Refunds for cancellations or returns are initiated within 3 working days.</li>
              </ul>

              {/* 7 */}
              <h2 className="mt-5 mb-3">7. Discounts & Promotional Offers</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Discounts may vary based on payment method or promotions.</li>
                <li>All applicable discounts are shown during checkout.</li>
                <li>MordenBazaar may modify or withdraw offers at any time.</li>
              </ul>

              {/* 8 */}
              <h2 className="mt-5 mb-3">8. Updates to Payment Policy</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This policy may be updated periodically.</li>
                <li>Major updates will be communicated via email or platform notice.</li>
                <li>Continued use of MordenBazaar implies acceptance of updates.</li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default PaymentPolicy;